import AxiosCustom from "../../components/common/apiConfigPouyan/index";



export function getCaptcha() {
  const config = {
    method: 'GET',
    url: "/Captcha/GetCaptcha"
  };

  const data = {};

  const header = {}

  return AxiosCustom(config, data, header);
}
